import * as actionConsts from './actions';
import update from 'react/lib/update';
import * as dailyReportActionConsts from '../actions';

export const initState = {
  description: "",
  englishDescription: null
}


export default (state=initState, action) => {
  switch (action.type) {
    case dailyReportActionConsts.DAILY_REPORT_GET_SUCCESS:
      return update(state, {
        description: {
          $set: action.description
        },
        englishDescription: {
          $set: action.englishDescription
        }
    });
    case actionConsts.DAILY_REPORT_UPDATE_DESCRIPTION:
      return update(state, {
        [action.typeOf]: {
          $set: action.value
        }
    });
    case actionConsts.TRANSLATE_DESCRIPTION_TEXT_SUCCESS:
      return update(state, {
        englishDescription: {
          $set: action.value
        }
    });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Description/reducer.js